<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1300"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      class="mb-0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              User Creation
            </h4>
            <p class="category font-weight-thin">
              Create and configure user
            </p>
          </div>
          <v-spacer />
          <v-btn  
            v-show="isDialogClosable()"
            text
            icon 
            color="white"
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-container
        v-if="loading"
        style="height: 150px;"
      >
        <v-row
          class="fill-height"
          align="center" 
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-row>     
      </v-container>
      <v-row
        v-else
      >
        <v-col>
          <v-stepper :value="step">
            <v-stepper-header>
              <v-stepper-step
                v-if="step < 5"
                :complete="step > 1"
                step="1"
              >
                Employee
              </v-stepper-step>
              <v-divider v-if="step < 3" />       

              <v-stepper-step
                v-if="step < 5"
                :complete="step > 2"
                step="2"
              >
                User
              </v-stepper-step>
              <v-divider v-if="step < 3" />

              <v-stepper-step
                v-if="step < 5"
                :complete="step > 3"
                step="3"
              >
                Report To
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items class="ma-0">                              
              <v-stepper-content 
                step="1" 
                class="pa-1"
              >
                <!-- prevent global validator from triggering -->
                <employee-form-create
                  v-if="step === 1 && dialog"
                  @created="createdEmployee"
                />
              </v-stepper-content>   

              <v-stepper-content
                step="2"
                class="pa-1"
              >
                <!-- prevent global validator from triggering -->
                <user-form-create
                  v-if="step === 2 && dialog"
                  :person-id="personId"
                  :person-name="name"
                  @created="createdUser"
                />              
              </v-stepper-content>

              <v-stepper-content 
                step="3" 
                class="pa-1"
              >
                <employee-report-to-form-create
                  v-if="step === 3 && dialog"
                  :employee-id="employeeId"
                  @edited="closeDialog"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      // UserApprovalLimitsFormEdit: () => import('@/components/user/ApprovalLimitsFormEdit'),
      // UserRolesFormCreate: () => import('@/components/user/roles/FormCreate'),
      // UserCompaniesFormCreate: () => import('@/components/user/companies/FormCreate'),
      UserFormCreate: () => import('@/components/user/FormCreate'),
      EmployeeFormCreate: () => import('@/components/employee/FormCreate'),
      EmployeeReportToFormCreate: () => import('@/components/employee/report-to/FormCreate'),
      // PayrollFormCreate: () => import('@/components/payroll/FormCreate'),
    },
    data () {
      return {
        step: 1,
        userId: null,
        personId: null,
        employeeId: null,
        employee: null,
        dialog: false,
        loading: false,
        name: null,
        reportTo: {},
      }
    },
    methods: {
      closeDialog () {     
        if (this.step > 2) {
          this.$emit('refreshList')
        }
        if (this.step === 3) {
          this.$api.employees().showOverview(this.employeeId)
            .then(response => {
              this.employee = response.data
              this.$emit('openProfile', this.employee)
            })
        }

        this.dialog = false
      },
      toggleDialog (propEmployee = null, reportTo) {      
        if (propEmployee !== null) {          
          this.employee = { ...propEmployee }

          this.employeeId = this.employee.employee_uid || ''
          this.personId = (this.employee.person || {}).person_uid || ''     
          this.userId = ((this.employee.person || {}).user || {}).user_uid || ''
          this.name = this.employee.person.name || ''
          this.reportTo = reportTo
          this.setPrimaryStep()
        } else {
          this.$resetData()
        }          

        this.dialog = true
      },
      isDialogClosable () {
        return this.step !== 2
      },
      createdEmployee (employeeUid, personUid, personName) {
        this.employeeId = employeeUid
        this.personId = personUid
        this.name = personName
        this.step = 2
      },
      createdUser (user) {
        this.userId = user.user_uid
        this.step = 3
      },   
      setPrimaryStep () {  
        if (this.isStepTwo()) {
          this.step = 2
        } else if (this.isStepThree()) {
          this.step = 3
        } else if (this.isStepFour()) {
          this.step = 4
        } else if (this.isStepFive()) {
          this.step = 5
        } else if (this.isStepSix()) {
          this.step = 6
        } else if (this.isStepSeven()) {
          this.step = 7
        }
      
      // else {
      //   this.loading = true

      //   this.$api.loginPeriods().count(this.userId)
      //     .then(response => {
      //       if (this.isStepFive(response.data)) {
      //         this.step = 5
      //       } else if (this.isStepSix()) {
      //         this.step = 6
      //       } else if (this.isStepSeven()) {
      //         this.step = 7
      //       } else {
      //         this.step = 8
      //       }

      //       this.loading = false
      //     })
      // } 
      },
      isStepTwo () {
        return (this.employee.person || {}).user === null
      },
      isStepThree () {
        return (this.reportTo === undefined)
      },
      isStepFour () {
        return (((this.employee.person || {}).user || {}).active_branches || []).length <= 0
      },
      // isStepFive (loginPeriods) {
      //   return loginPeriods[0] === 0
      // },
      isStepFive () {
        return (((this.employee.person || {}).user || {}).roles || []).length <= 0
      },
      isStepSix () {
        return (((this.employee.person || {}).user || {}).crm_roles || []).length <= 0
      },
    },
  }
</script>
